export default () => ({
    showAllOrders: false,

    init() {
        const url = new URL(window.location.href)
        const params = new URLSearchParams(url.search)

        if (params.has('orders')) {
            this.showAllOrders = true

            const dashboardLink = document.getElementById(
                'account-nav-dashboard'
            )
            const ordersLink = document.getElementById('account-nav-orders')

            const dashboardLinkClasses = Array.from(dashboardLink.classList)
            const ordersLinkClasses = Array.from(ordersLink.classList)

            dashboardLink.classList.remove(...dashboardLinkClasses)
            dashboardLink.classList.add(...ordersLinkClasses)

            ordersLink.classList.remove(...ordersLinkClasses)
            ordersLink.classList.add(...dashboardLinkClasses)
        }
    },
})
